/**
 * 字典信息
 */
import React from "react";
import { Button, Row, Col, Icon, Tooltip } from "antd";
import PageLayout from "../../ui/PageLayout";
import FeeRuleEdit from "./FeeRuleEdit";
import http from "../../../axios/http";
import { global_data } from '../../ui/auth'

class FeeRuleIndex extends React.Component {
  columns = [
    {
      title: "名称",
      dataIndex: "name",
      width: "20%",
    },
    {
      title: "生效区域",
      dataIndex: "zone",
      width: "20%",
      render: (text, record, index) => {
        var zoneName = "";
        this.state.parkZones.forEach((row) => {
          if (row.code === text) {
            zoneName = row.name;
          }
        });
        return zoneName;
      },
    },
    {
      title: "免费时长(分钟)",
      dataIndex: "freeMinute",
      width: "15%",
    },
    {
      title: "起收价格(元)",
      dataIndex: "startFee",
      width: "15%",
    },
    {
      title: "累进价格(元)",
      dataIndex: "stepFee",
      width: "15%",
    },
    {
      title: "每日封顶(元)",
      dataIndex: "capFee",
      width: "15%",
    },
    {
      title: "月租价格(元)",
      dataIndex: "monthFee",
      width: "15%",
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "15%",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_FEERULE_UPDATE")?
          <Tooltip title="修改">
            <Icon
              type="edit"
              theme="filled"
              title="修改"
              className="table-operate-icon"
              onClick={this.update.bind(this, record)}
            />
          </Tooltip>
          :""}
        </div>
      ),
    },
  ];

  state = {
    visible: false,
    editData: {},
    loadData: "",
    queryData: {},
    parkZones: [],
  };

  add = () => {
    this.setState({ editData: {} });
    this.showModal();
  };

  loadParkZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };

  componentWillMount() {
    this.loadParkZone();
  }

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  update = (info, e) => {
    this.setState({ editData: info });
    this.showModal();
  };

  inputSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["name"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={8}>收费规则清单</Col>
              <Col span={16} style={{ textAlign: "right" }}>
              {global_data.authCode.includes("BARRIER_FEERULE_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="code"
          url="/barrier/feeRule/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <FeeRuleEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
          queryData={this.state.queryData}
        />
      </div>
    );
  }
}

export default FeeRuleIndex;
